import { DriverSafetySummary, SafetySummary, SafetyPeriodView } from "../../../models";
import { getSafetyReport } from "./getSafetyReport";

const getSummary = (s: any): SafetySummary => ({
  weightedScore: s?.weighted_score ?? undefined,
  reportCount: s?.report_count ?? 0,
  totalDriveMinutes: s?.total_drive_minutes ?? 0,
  totalDriveMiles: s?.total_drive_miles ?? 0,
});

const getPeriod = (p: any): SafetyPeriodView => ({
  id: p?.id,
  startDate: p?.start_date,
  endDate: p?.end_date,
  previousId: p?.previous_id ?? undefined,
  nextId: p?.next_id ?? undefined,
});

export const getDriverSafetySummary = (data: any): DriverSafetySummary => ({
  payPeriod: getPeriod(data?.pay_period),
  summary: getSummary(data?.summary),
  reports: (data?.reports || []).map(getSafetyReport),
});
